import React, { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "./Sidebar";
import Navbar from "./Navbar";
import { useLocation } from "react-router-dom";
import toastr from "toastr";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Invoice = () => {
  const [invoiceData, setInvoiceData] = useState("");
  const location = useLocation();
  const { orderid } = location.state;
  const [batchNo, setBatchNo] = useState("");
  const [expDate, setExpDate] = useState("");

  const history = useHistory();
  const totalPriceqty =
    invoiceData?.products &&
    invoiceData.products.reduce(
      (total, item) => total + item.price * item.quantity,
      0
    );

  const calTax = (totalPriceqty * invoiceData?.applicable_tax) / 100;

  const orderTotal = totalPriceqty + calTax + invoiceData?.delivery_fee;

  console.log(orderTotal)

  const fetchInvoiceData = async () => {
    try {
      const response = await axios.get(
        `http://api.meddaily.in/order_details?order_id=${orderid}`,
        {
          headers: {
            token: localStorage.getItem("disToken"),
          },
        }
      );
      if (response.status === 200) {
        setInvoiceData(response?.data?.data);
        console.log(response.data.data);
      }
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    fetchInvoiceData();
  }, [orderid]);

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const options = {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      hour12: true,
    };
    const formattedDate = date.toLocaleDateString("en-US", options);
    return formattedDate.replace(",", " AT");
  };

  const sendAndShip = async () => {
    const requestBody = {
      batch_no: batchNo,
      exp_date: expDate,
      order_id: orderid,
    };

    try {
      const response = await axios.post(
        "http://api.meddaily.in/create_invoice",
        requestBody,
        {
          headers: {
            token: localStorage.getItem("disToken"),
          },
        }
      );
      if (response.status === 200) {
        toastr.success("Invoice created successfully");
        history.push("/orderlist");
      }
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Sidebar />
          <div className="layout-page">
            <Navbar />

            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <div className="row">
                  <div className="card mb-12">
                    <div className="card-header d-flex justify-content-between align-items-center"></div>

                    <hr className="my-0" />
                    <div className="card-body">
                      <div className="container-xxl flex-grow-1 container-p-y">
                        <div className="row">
                          <div className="card">
                            <h5 className="card-header float-start">
                              Create Invoice
                            </h5>
                            {invoiceData ? (
                              <div className="card">
                                <div className="row">
                                  <div className="col-md text-start">
                                    <p>
                                      ORDER ID: {invoiceData.order_id}
                                      <br />
                                      Created At:{" "}
                                      {formatDate(invoiceData.createdAt)}
                                      <br />
                                      Retailer:{" "}
                                      {invoiceData.retailer_name
                                        ? invoiceData.retailer_name
                                        : "N/A"}
                                      <br />
                                      Address:{" "}
                                      {invoiceData.retailer_address
                                        ? invoiceData.retailer_address
                                        : "N/A"}
                                    </p>
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <p>No invoice data available.</p>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="card">
                        {/* <div className="row">
                          <div className="col-md">
                            <p>{invoiceData.products[0]?invoiceData.products[0].name:"NA"}</p>
                          </div>
                          <div className="col-md">
                            <p>{invoiceData?.products[0]?.price}</p>
                          </div>
                          <div className="col-md">
                            <p>{invoiceData?.products[0]?.quantity}</p>
                          </div>
                        </div> */}
                        {invoiceData &&
                          invoiceData.products &&
                          invoiceData.products.length > 0 && (
                            <div className="row">
                              <div className="col-md">
                                <p>
                                  Name : {invoiceData.products[0].name || "NA"}
                                </p>
                              </div>
                              <div className="col-md">
                                <p>Price : {invoiceData.products[0]?.price}</p>
                              </div>
                              <div className="col-md">
                                <p>
                                  Quantity : {invoiceData.products[0]?.quantity}
                                </p>
                              </div>
                            </div>
                          )}

                        <div className="card">
                          <div className="row mb-5">
                            <div className="col-md text-start ">
                              <label htmlFor="batch">Batch no.</label>
                              <input
                                type="text"
                                name="batch"
                                id="batch"
                                className="form-control"
                                value={batchNo}
                                onChange={(e) => setBatchNo(e.target.value)}
                              />
                            </div>
                            <div className="col-md text-start">
                              <label htmlFor="exp">Exp Date.</label>
                              <input
                                type="text"
                                name="exp"
                                id="exp"
                                className="form-control"
                                value={expDate}
                                onChange={(e) => setExpDate(e.target.value)}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="card mt-3">
                          <div className="row">
                            <div className="text-start">
                              <h4>Bill Details</h4>
                            </div>
                            <div className="row">
                              <div className="col-md text-end">
                                <p> item Total: Rs.{totalPriceqty}</p>{" "}
                                <p>
                                  Delivery Fee: Rs.{invoiceData.delivery_fee}
                                </p>{" "}
                                <p> Taxes and Charge: Rs.{calTax}</p>
                              </div>
                            </div>
                            <hr />
                            <div
                              className="text-end"
                              style={{ paddingRight: "50px" }}
                            >
                              <p>
                                <strong>
                                  Order Total:
                                  {orderTotal}
                                </strong>
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <div>
                      <button
                        className="btn btn-primary mb-5"
                        onClick={sendAndShip}
                        style={{
                          backgroundColor: "#6eafab",
                          border: "1px solid #6eafab",
                        }}
                      >
                        Send & Ship
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Invoice;
